import {
  jb_youtube_icon_css_default
} from "./chunk.IEQTVL6E.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Icon
} from "./chunk.6P2PIW72.js";
import {
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/icons/jb-youtube-icon/jb-youtube-icon.ts
var JbYoutubeIcon = class extends Icon(r) {
  render() {
    return ke`
      <svg
        fill="currentColor"
        viewbox="0 0 22 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.25 3.926c.002.02.203 1.67.203 3.292v1.527c0 1.626-.2 3.273-.202 3.29-.011.067-.217 1.495-.88 2.164-.761.796-1.61.88-2.066.925l-.122.013c-2.623.19-6.486.21-7.01.212h-.065c-.527-.002-4.388-.023-6.998-.21l-.135-.015c-.459-.045-1.306-.129-2.07-.929-.66-.665-.867-2.093-.875-2.153a30.83 30.83 0 0 1-.203-3.297V7.218c0-1.623.2-3.272.202-3.286.009-.067.216-1.495.88-2.167C2.67.97 3.518.888 3.975.845l.12-.014c2.623-.19 6.48-.205 7.008-.208h.062c.532.003 4.393.019 7.005.206l.135.016c.456.043 1.305.124 2.068.924.66.668.867 2.096.877 2.157m-6.651 4.328a.29.29 0 0 0 .157-.259l-.156-.258-5.433-2.834-.286.009-.14.248v5.65l.14.247.152.045.134-.034L14.6 8.254"
        ></path>
      </svg>
    `;
  }
};
JbYoutubeIcon.styles = jb_youtube_icon_css_default;
JbYoutubeIcon = __decorateClass([
  customElement("jb-youtube-icon")
], JbYoutubeIcon);

export {
  JbYoutubeIcon
};
